import type { FieldErrors, FieldValues } from "react-hook-form";

export function collectErrorMessages<T extends FieldValues>(errors: FieldErrors<T>): string[] {
  const messages = new Set<string>();
  const walk = (node: unknown) => {
    if (!node || typeof node !== "object") return;
    if ("message" in node && typeof (node as { message?: unknown }).message === "string") {
      messages.add((node as { message: string }).message);
      return;
    }
    for (const value of Object.values(node)) {
      walk(value);
    }
  };
  walk(errors);
  return Array.from(messages);
}

export function pickErrorMessages<T extends FieldValues>(errors: FieldErrors<T>, keys: readonly string[]): string[] {
  const source = errors as Record<string, unknown>;
  const subset = Object.fromEntries(keys.map((key) => [key, source[key]]));
  return collectErrorMessages(subset as FieldErrors<T>);
}
